<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="template">
        <v-row>
            <v-col cols="12" class="text-center mt-4 ">
                <h3 class="text-center kbDarkBlueText--text">{{ $t('general.template') }}</h3>
                <span class="kbDarkBlueText--text">{{ $t('general.pickOrCreateTemplate') }}</span>
            </v-col>

            <v-col cols="12">
                <v-row class="mx-2"  justify="center" >
                    <v-select v-model="draftedDesigns"
                              color="kbDarkBlueText"
                              style="max-width: 500px"
                              class="py-6"
                              hide-details
                              outlined
                              :items="listTemplates"
                              item-text="name"
                              item-value="_id"
                              :label="$t('general.pickTemplate')"
                              return-object
                              single-line
                              clearable>
                    </v-select>
                </v-row>
            </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4" ></v-divider>
        <v-row class="fill-height" align="center" justify="center"  >
            <v-col cols="12" class="text-center" >
                <v-btn color="kbGrayText"
                       @click="updateStep(4)"
                       outlined
                       class="float-left">
                    <v-icon dark>keyboard_arrow_left</v-icon>
                    <span class="hidden-xs-only">{{ $t('general.goBack') }}</span>
                </v-btn>
                <v-btn color="kbPurple"
                       dark
                       @click="updateStep(6)"
                       class="float-right">
                    <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
                    <v-icon dark>keyboard_arrow_right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'draftDesign',
  async created () {
    await this.$store.dispatch('getTemplates')
  },
  computed: {
    ...mapState({
      templatesList: state => state.campaigns.templates
    }),
    listTemplates () {
      let listOfTemplates = []
      listOfTemplates = listOfTemplates.concat(this.templatesList)
      return listOfTemplates
    },
    draftedDesigns: {
      get () {
        return this.$store.state.campaigns.selectTemplate
      },
      set (value) {
        this.$store.commit('SET_SELECT_TEMPLATES', value)
      }
    }

  },
  methods: {
    updateStep (step) {
    //    if (!this.selectTemplate && step === 5) return notifications.error(this.$t('general.noTemplatePicked'))
      this.$emit('draft', step)
    }
  },
  props: ['step']
}
</script>
